<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a  @click="backButton"><li>Liabilities</li></a>
      <a  @click="depositeDashbord"><li>&nbsp;>&nbsp;Consumer Loan</li></a>

      <li>&nbsp;>&nbsp;Consumer Loan</li>
    </ul>
    <h4 class="welcome-text">Consumer Loan</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"
          @submit.prevent
          class="login-form-box register-page"
          lazy-validation
        >
            <h4>Enter Details</h4>
            <v-row >
              <v-col xs="12" md="6" class="member_relation_box col" v-for="formAttr in formAttributes" :key="formAttr.id">
                <label class="member-label" v-if="formAttr['name'] =='current_value'">Current Value as on {{currentDate | moment("DD MMM, YY")}}</label>
                <label class="member-label" v-else-if="formAttr['name'] =='market_price'">Market Price as on {{currentDate | moment("DD MMM, YY")}}</label> 
                <label class="member-label" v-else-if="formAttr['name'] =='nav'">Nav as on {{currentDate | moment("DD MMM, YY")}}</label>
                <label class="member-label" v-else>{{formAttr['label']}} </label>
                <div v-if="formAttr['type'] == 'select' && formAttr['name'] !='nominee'">
                  
                  <v-select
                    ref="form_attrs"
                    :name="formAttr['name']"
                    :v-model="formAttr['name']"
                    :items="(formAttr['name']=='bank_name' )? bank : (formAttr['name']=='account_owner')? account_owner :(formAttr['name']=='liability_type')? liability_type:formAttr['name']=='insurance' ? insurance : formAttr['name']=='emi_date' ? emi_day :  formAttr['name'] == 'joint_account_owner' ? joint_account_owner : []"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                  ></v-select>
                </div>
                <div v-else-if="formAttr['type'] == 'select' && formAttr['name'] =='nominee'">
                   <v-combobox
                    :ref="formAttr['name']"
                    :name="formAttr['name']"
                    v-model="addMoreField"
                    :items="nominee"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                    multiple
                    small-chips
                    solo
                    v-on:input="limiter"
                    deletable-chips
                  ></v-combobox>
                  <a @click="appendField" class="add-newbox">Add New Nominee</a>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'loan_account_no'" :class=" formAttr['icon'] == 'rupyee.png' ? 'rupee-icon' : ''">
                    <v-text-field
                    :name="formAttr['name']"
                    :maxlength="length_limit"
                    ref="form_attrs"
                    :rules="[(formAttr['is_required'] ==true ? v => !!v || 'Field is required':[]),(formAttr['is_numeric'] ==true ? v => /^\d*\.?\d*$/.test(v) || 'Field must be numeric':[])]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateAmounts()"
                    :value="formAttr['name'] == 'symbol'? symbol:formAttr['name'] == 'market_price'? market_price : formAttr['name'] == 'current_value' ? current_value : formAttr['name'] == 'tenure_left' ? tenure_left : formAttr['name'] == 'liability_type' ? formAttr['value']:''"
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'input'" :class=" formAttr['icon'] == 'rupyee.png' ? 'rupee-icon' : ''">
                    <v-text-field
                    :disabled="(formAttr['name'] == 'current_balance' )|| (formAttr['name'] == 'maturity_amount') ? true: false"
                    :name="formAttr['name']"
                    :maxlength="length_limit"
                    ref="form_attrs"
                    :rules="[(formAttr['is_required'] ==true ? v => !!v || 'Field is required':[]),(formAttr['is_numeric'] ==true ? v => /^\d*\.?\d*$/.test(v) || 'Field must be numeric':[])]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateAmounts()"
                    :readonly="formAttr['name'] == 'nav' || formAttr['name'] == 'current_value' || formAttr['name'] == 'symbol'|| formAttr['name'] == 'market_price' || formAttr['name'] == 'tenure_left' || formAttr['name'] == 'liability_type'"

                    :value="formAttr['name'] == 'symbol'? symbol:formAttr['name'] == 'market_price'? market_price : formAttr['name'] == 'current_value' ? current_value : formAttr['name'] == 'tenure_left' ? tenure_left : formAttr['name'] == 'liability_type' ? formAttr['value']:''"
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'date' && formAttr['name'] == 'start_date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="yyyy-MM-dd"
                    :placeholder="formAttr['place_holder']"
                    :disabledDates="disabledDatesforloan"
                     :value="formAttr['value']"
                  ></Datepicker>
                </div>
                <div v-else-if="formAttr['type'] == 'date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']"
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    :disabledDates="formAttr['name'] == 'expiry_date' ?disabledDates: formAttr['name'] == 'loan_outstanding_date' ?disabledDatesforloan:{}"
                    format="yyyy-MM-dd"
                    :placeholder="formAttr['place_holder']"
                    @selected="calculateAmountsWithDates($event, formAttr['name'])"
                  ></Datepicker>
                </div>
              </v-col>
            </v-row>
           
            <span
              v-bind:class="{'error-messagebox-login': isAddClassServerError}"
              id="server_side_error"
              >{{serverError}}</span
            >
            <v-row class="buttonbox">
              <v-btn class="blue-border-btn" @click="depositeAccounts"> Cancel </v-btn>
              <v-btn
                class="blue-btn"
                @click="submit"
                :disabled="!isFormValid"
                
              >
                Save
              </v-btn>
            </v-row>
          </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { validationMixin } from 'vuelidate'
import {required, email, minLength, sameAs, isAlphanumeric, alpha, numeric, maxLength} from "vuelidate/lib/validators";
import { Auth } from 'aws-amplify';
import { GET_CONSUMER_FORM, SAVE_LIABILITY_FORM_DETAIL, GET_LIABILITY_FORM_DETAIL } from "../../../store/actions.type";
import { isEmpty } from 'lodash';
export default {
    components: {
      Datepicker,
    },
    mixins: [validationMixin],
    validations: {
     
    },
    data: () => ({
      valid: true,
      submitted: false,
      activePicker: null,
      menu: false,
      isFormValid:false,
      disabledDates: {
        to: new Date()
      },
      serverError:'',
      isAddClassServerError:false,
      formAttributes:'',
      formAttr:'',
      other_form_field:[],
      length_limit:20,
      familyMember:[],
      nominee:[],
      other_nominee:[],
     
      curr_balance_date: '',
      account_type:'',
      bank_name:'',
      account_owne:'',
      addMoreField:[],
      nomineeMembers:[],
      form_id:'',
      account_owner:[],
      joint_account_owner:[],
      nominee:[],
      currentDate: new Date().setDate(new Date().getDate()),
      scheme_name:[],
      current_value:'',
      exchange:[],
      symbol:'',
      market_price:'',
      security_list:[],
      bank:[],
      liability_type:[],
      insurance:[],
      start_date:'',
      expiry_date:'',
      emi_date:'',
      tenure_days:'',
      tenure_left:'',
      emi_day:[],
      loan_outstanding_date:'',
       disabledDatesforloan: {
        from: new Date()
      },
    }),
    created (){
      Fire.$on("loadData", () => {
        this.getLaibilityFormData();
      });
    },
    mounted (){
      if (isEmpty(this.$store.getters.getConsumerForm)) {
        this.getLaibilityFormData();
      }else{
        this.form_id = this.$store.getters.getConsumerForm.data.form_id;
        this.formAttributes = this.$store.getters.getConsumerForm.data.form_attributes.fields;
        let masterDataArr = this.$store.getters.getConsumerForm.data.master_data;
  
        masterDataArr.forEach(element => {
          if (element.Bank) {
            element.Bank.forEach(bankName => {
              this.bank.push({'id':bankName.id, 'name':bankName.name});
            });
          }
          if (element.FamilyMember) {
              element.FamilyMember.forEach(dataFamily => {
                this.nominee.push(dataFamily.name);
                if(dataFamily.id == 0){
                  this.account_owner.push({'id':'0', 'name':dataFamily.name});
                }
                else{
                  this.account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
                }
                this.joint_account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
            } );
          }
          if (element.InsuranceType) {
            element.InsuranceType.forEach(insurance => {
                if(insurance.id == 0){
                  this.insurance.push({'id':'0', 'name':insurance.name});
                }
                else{
                  this.insurance.push({'id':insurance.id, 'name':insurance.name});
                }
            });
          }
          if (element.EMIDate) {
            element.EMIDate.forEach(emidate => {
                if(emidate.id == 0){
                  this.emi_day.push({'id':'0', 'name':emidate.name});
                }
                else{
                this.emi_day.push({'id':emidate.id, 'name':emidate.name});
                }
            });
          }
        });
      }
    },
    methods: {
      limiter(e) {
      if((e.length + this.other_form_field.length) > 3) {
        swal.fire({
              title: 'Nominee',
              text: "You can add maximum 3 nominees.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                e.pop();
                return;
              }
            })
      }
    },
      validate () {
        this.$refs.form.validate()
      },
      backButton(){
        this.$router.push({ name: 'liabilities-subcategory'}).catch(()=>{});
      },
      depositeAccounts(){
        this.$router.push({ name: 'liabilities-dashboard'}).catch(()=>{});
      },
      appendField(){
         swal.fire({
          input: 'text',
          inputPlaceholder: 'Enter Nominee',
          inputAttributes: {
          autocapitalize: 'off'
          },
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Save`,
          denyButtonText: `Don't save`,
          allowOutsideClick: false,
          allowEscapeKey: false
          }).then((result) => {
            if (result.value) {
              let letters = /^[A-Za-z]+$/;
            if(result.value.length > 30){
                 swal.fire({
                  title: 'Nominee',
                  text: "Nominee Name may not be greater than 30 character.",
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#051d42',
                  confirmButtonText: 'OK',
                  }).then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                })
              }else if (result.value.match(letters)) {
              this.nominee.push(result.value);
              this.addMoreField.push(result.value);
            } else {
              swal
                .fire({
                  title: "Nominee",
                  text: "Please enter valid name.",
                  icon: "warning",
                  showCancelButton: false,
                  confirmButtonColor: "#051d42",
                  confirmButtonText: "OK",
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                });
            }
          }
            if (result.value == "") {
            swal
              .fire({
                title: "Nominee",
                text: "This field is required.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#051d42",
                confirmButtonText: "OK",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  e.pop();
                  return;
                }
              });
          }
          })
       
        if (this.addMoreField.length >= 3) {
         swal.fire({
              title: 'Nominee',
              text: "You can add maximum 3 nominees.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                e.pop();
                return;
              }
            })
        }
      },
      removeField (lineId) {
        this.other_form_field.splice(lineId, 1);
      },
      setData(key){
        
      },
      submit(e) {
        if (this.loan_outstanding_date && this.start_date) {
          if (this.start_date > this.loan_outstanding_date) {
            swal
              .fire({
              title: "Loan Outstanding Date should be after Start date.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
              }).then(() => {
                
              }) 
              return;
            }
        }

        if (this.expiry_date && this.start_date) {

           if(this.start_date > this.expiry_date){
            swal
              .fire({
              title: "Expiry Date should be after Start date.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
              }).then(() => {
                
              })
              return;
            }
        }
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        if(this.checkFormData.length > 1){
        this.submitted = true;
        let jsonObject = []
        let nominee    = []
        let i=0;
        for (const [key, value] of formData.entries()) {
          if(key == 'nominee' && value !=''){
            value.split(",").forEach(nomineeData => {
              nominee.push(nomineeData)
            });
          }
          else if(Number.isInteger(parseInt(key)) == true){
            nominee.push(value)
          }
          
          else if(key == 'account_owner' || key == 'joint_account_owner' || key == 'bank_name' || key == 'emi_date' || key == 'insurance'){
            jsonObject.push({"key":key, "values":(value !='')?parseInt(value):value})
          }
          else{
            if(key != 'nominee'){
              jsonObject.push({"key":key, "values":value })
            }
          }
          i++;
        }
        let nomineeArr = {"key":"nominee", "values":nominee}
        jsonObject.push(nomineeArr)
        let collected_data = {"collected_data":jsonObject};
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        this.$store.dispatch(SAVE_LIABILITY_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            form_id:this.form_id,
            account_owner:getFormData.account_owner.value,
            form_detail:JSON.stringify(collected_data),
            form_type:'liability',
          },
          api: 'save-liability-form-detail',
        }).then(() => {
           this.savingAccountList();
            this.$loading(false)
            Toast.fire({
                icon: "success",
                title: "Data added successfully.",
            });
            this.$router.push({ name: "liabilities-dashboard", params: { tab: 'tab-7' }}).catch(()=>{});
        }).catch(() => {
            this.$loading(false)
        })
      }
       
      },
      setMasterData:function(attr_type, val){
        if (attr_type == 'account_owner') {
         let masterDataArr = this.$store.getters.getConsumerForm.data.master_data;
          let i = 0;
          this.joint_account_owner = [];
          masterDataArr['0']['FamilyMember'].forEach(
            familyMember => {
              if (parseInt(val) != parseInt(familyMember['id'])) {
                  this.joint_account_owner.push({'id':familyMember.id, 'name':familyMember.name});
              }
              i++;
          });
        }
        this.isFormValid = this.$refs.form.validate();
      },
      appendFieldOnNominee(attr_type, val){
        this.nominee.push(val);
        this.addMoreField.push(val);
        this.other_form_field.splice(attr_type, 1);
      },
      depositeDashbord(){
        this.$router.push({ name: "liabilities-dashboard"}).catch(()=>{});
      },

      calculateAmounts(){
        this.isFormValid = this.$refs.form.validate()
      },
      calculateAmountsWithDates(event,name){
        if (name == 'start_date') {
          this.start_date = event;
        }

        if (name == 'expiry_date') {
          this.expiry_date = event;
          this.tenure_left  =  moment(moment(this.expiry_date).format('DD-MM-YYYY'), 'DD-MM-YYYY').diff( moment(moment(this.currentDate).format('DD-MM-YYYY'), 'DD-MM-YYYY'), 'days')
        }

        if(this.expiry_date < this.currentDate){
          this.tenure_left = '';
        }

        if ((this.start_date != '') && (this.expiry_date != '') && (name != 'emi_date')) {

              (this.start_date > this.expiry_date) ?  swal
              .fire({
              title: "Expiry Date should be after   Start date.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
              }).then(() => {
                
              }):'';


              (this.expiry_date < this.start_date) ?  swal
              .fire({
              title: "Expiry Date should be after   Start date.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
              }).then(() => {
                
              }):'';
        }

        if (name == 'loan_outstanding_date') {
          this.loan_outstanding_date = event;
        }

        if (this.loan_outstanding_date && this.start_date) {

           (this.start_date > this.loan_outstanding_date) ?  swal
              .fire({
              title: "Loan Outstanding Date should be after   Start date.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
              }).then(() => {
                
              }):'';
        }

      },
      getLaibilityFormData(){
        if(this.$store.getters.getUserDetails.user_name != undefined){  
          this.$loading(true);
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let user_name =  this.$store.getters.getUserDetails.user_name;
          let selected_value = this.$store.getters.getUserDetails.selected_value;
          this.$store.dispatch(GET_CONSUMER_FORM, {
            data: {
              aws_cognito_id: cognito_idp,
              user_name:user_name,
              form_type: 14,
            },
            api: "get-liability-form",
          })
          .then(() => {
            this.form_id = this.$store.getters.getConsumerForm.data.form_id;
            this.formAttributes = this.$store.getters.getConsumerForm.data.form_attributes.fields;
            let masterDataArr = this.$store.getters.getConsumerForm.data.master_data;
      
            masterDataArr.forEach(element => {
              if (element.Bank) {
                element.Bank.forEach(bankName => {
                  this.bank.push({'id':bankName.id, 'name':bankName.name});
                });
              }
              if (element.FamilyMember) {
                  element.FamilyMember.forEach(dataFamily => {
                    this.nominee.push(dataFamily.name);
                  if(dataFamily.id == 0){
                  this.account_owner.push({'id':'0', 'name':dataFamily.name});
                  }
                  else{
                    this.account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
                  }      
                  this.joint_account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
                } );
              }
              if (element.InsuranceType) {
                element.InsuranceType.forEach(insurance => {
                  this.insurance.push({'id':insurance.id, 'name':insurance.name});
                });
              }
              if (element.EMIDate) {
                element.EMIDate.forEach(emidate => {
                  if(emidate.id == 0){
                  this.emi_day.push({'id':'0', 'name':emidate.name});
                  }
                  else{
                  this.emi_day.push({'id':emidate.id, 'name':emidate.name});
                  }
                });
              }
            });
            this.$loading(false)
          })
          .catch(function (error) {
             
          });            
        }
      },
      savingAccountList() {
        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name = this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
       
        this.$store.dispatch(GET_LIABILITY_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            member_id: selected_value,
          },
          api: "get-liability-form-detail",
        })
        .then(() => {
          Fire.$emit("updateLiabilityData");
            this.$loading(false);
        })
        .catch(() => {
            this.$loading(false);
        });
      },
    }
};
</script>